import { render, staticRenderFns } from "./priceCard.vue?vue&type=template&id=765a7f3c&scoped=true"
import script from "./priceCard.vue?vue&type=script&lang=js"
export * from "./priceCard.vue?vue&type=script&lang=js"
import style0 from "./priceCard.vue?vue&type=style&index=0&id=765a7f3c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765a7f3c",
  null
  
)

export default component.exports